import Fingerprint2 from 'fingerprintjs2';
import canUseDom from '@clearscore/helpers.can-use-dom';
import { cache } from '@clearscore/helpers.cache';
import device from '@clearscore/helpers.device';

// eslint-disable-next-line import/no-mutable-exports
const fingerprint = {
    component: [],
    hash: 'server',
    calculate: function fingerprintPromise() {
        return new Promise((resolve) => {
            Fingerprint2.get(function (components) {
                const values = components.map(function (component) {
                    return component.value;
                });

                resolve(Fingerprint2.x64hash128(values.join(''), 31));
            });
        });
    },
};

const options = {
    extraComponents: [
        {
            key: 'osAndBrowser',
            getData(done) {
                done(device.DEVICE_NAME);
            },
        },
    ],
    excludes: {
        // N.B. - [1] These are default fingerprint.js exlucdes copied over from:
        // https://github.com/Valve/fingerprintjs2/blob/54e89b2ebdbf33853a85a7be43bd17e8b859cfc6/fingerprint2.js#L256

        // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
        enumerateDevices: true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        pixelRatio: true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        doNotTrack: true,
        // uses js fonts already
        fontsFlash: true,

        // N.B. - [2] These are custom ClearScore values
        colorDepth: true,
        screenResolution: true,
        availableScreenResolution: true,
        plugins: true,
        fonts: true,
        canvas: true,
        adBlock: true,
        webgl: true,
        audio: true,
        // Handled by the `osAndBrowser` in `extraComponents` as user agent changes too frequently
        userAgent: true,
    },
};

function calculateFingerprint() {
    Fingerprint2.get(options, function (components) {
        fingerprint.components = components;
        const values = components.map(function (component) {
            return component.value;
        });

        fingerprint.hash = Fingerprint2.x64hash128(values.join(''), 31);

        cache.device = {
            hash: fingerprint.hash,
            components: fingerprint.components,
        };
    });
}

if (canUseDom()) {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(calculateFingerprint);
    } else {
        setTimeout(calculateFingerprint, 500);
    }
}

export default fingerprint;
